
// Build Image URL
export const imageUrl = (filename)=>{
  const base = 'https://lancaster-images.s3.amazonaws.com/merchandising/'
  return base + filename
}

// Match on item ID against data array of item details returning match/detail
export const itemMatch = (id, items)=>{
  let match = _.find(items, i => i.id == id)
  if(match){
    match.imageUrl = imageUrl(match.imageFilename)
    return match
  }
  return null
}

// Customer search logic
export const customerSearch = (list, query)=>{
  return _.take(
    _.filter(list, function(c){
      return _.every(query.split(' '), q => {
        return(
          c.id?.toString().includes(q) ||
          c.name?.toLowerCase().includes(q) ||
          c.address1?.toLowerCase().includes(q) ||
          c.zip_code?.toLowerCase().includes(q) ||
          c.city?.toLowerCase().includes(q)
        )
      })
    }), 10
  )
}